// Keeps --sticky-offset in sync with whatever is currently pinned to the
// top of the viewport (sticky header, and the sticky countdown bar when
// live), so .article-sidebar__sticky never sticks underneath them.
// Recomputes on resize and whenever those elements' classes change
// (how header.js/section-countdown.css signal a stuck-state change) —
// no scroll listener needed since position: sticky already handles the
// pinning itself, this only tracks how much space that pinning occupies.
(() => {
  const header = document.querySelector('.section-header');
  const countdown = document.querySelector('.section-countdown-container');

  if (!header && !countdown) return;

  function updateStickyOffset() {
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    const countdownBottom = countdown ? countdown.getBoundingClientRect().bottom : 0;
    const offset = Math.max(0, headerBottom, countdownBottom);

    document.documentElement.style.setProperty('--sticky-offset', `${offset}px`);
  }

  updateStickyOffset();

  window.addEventListener('resize', updateStickyOffset);

  [header, countdown].forEach((element) => {
    if (!element) return;
    new MutationObserver(updateStickyOffset).observe(element, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });
})();
